export class BulletItem {

  constructor(containerSelector = '.uitleg-vakken') {
    this.container = document.querySelector(containerSelector);
    if (!this.container) {
      return;
    }
    this.addEventListeners();
  }

  addEventListeners() {
    this.container.addEventListener('click', this.handleItemClick.bind(this));
  }

  handleItemClick(event) {
    const clickedItem = event.target.closest('.bullet-item');
    if (!clickedItem) return;

    this.removeActiveClassFromAllItems();
    this.addActiveClassToItem(clickedItem);
    this.changeURLParameter(clickedItem);
  }

  removeActiveClassFromAllItems() {
    // manage the bullet items
    const activeItems = this.container.querySelectorAll('.bullet-item.active');
    activeItems.forEach(item => item.classList.remove('active'));

    // manage the bullet content
    const activeContents = this.container.querySelectorAll('.bullet-content:not(.hidden)');
    activeContents.forEach(item => item.classList.add('hidden'));
  }

  addActiveClassToItem(item) {
    // Manage the bullet item
    item.classList.add('active');

    // Manage the bullet content
    const target = item.dataset.target;
    const activateContent = this.container.querySelectorAll('.bullet-content.' + target);
    activateContent.forEach(item => item.classList.remove('hidden'));

  }

  changeURLParameter(item) {
    const target = item.dataset.target;
    const url = new URL(window.location);
    url.searchParams.set('vak', target);
    history.pushState(null, '', url);
  }
}
